import React, { useState, useEffect, useRef } from "react";
//import Peer from "peerjs";
import DailyIframe from "@daily-co/daily-js";
import { useParams, useNavigate } from "react-router-dom";
import { notification, Form, Row, Col, Card, Button, Layout } from "antd";
// import LogoBid from "../assets/img/png/bidlab.png";
// import LogoCiti from "../assets/img/png/citifundation.png";
import VideoCameraOutlined from "@ant-design/icons/VideoCameraOutlined";
import "./Eventos.scss";
import Logo from "../assets/img/png/logo.png";
import CloseCircleOutlined from "@ant-design/icons/CloseCircleOutlined";

// import { returnMailImage } from "../utils/functions";

import { getEventByUrlApi, UpdateLocationEventApi } from "../api/event.api";

import ModalUser from "../components/Admin/ModalUser";
import { log } from "@antv/g2plot/lib/utils";

//import errorpermisos from "../assets/img/png/error.png";

export default function Eventos() {
  const [event, setEvent] = useState();
  // const [formPersonal] = Form.useForm();

  // const [peerId, setPeerId] = useState("");
  // const remoteVideoRef = useRef(null);
  // const currentUserVideoRef = useRef(null);
  // const peerInstance = useRef(null);
  // const [mediaRecorder, setMediaRecorder] = useState(null);
  // const [recordedChunks, setRecordedChunks] = useState([]);
  const [isInCall, setIsInCall] = useState(false);
  const [calling, setCalling] = useState(false);
  const { Header, Content } = Layout;
  const { evento } = useParams();

  const callFrame = useRef(null);
  // const [isJoined, setIsJoined] = useState(false);
  const [tokendaily, setTokendaily] = useState();

  // const [videoEnabled, setVideoEnabled] = useState(true);
  // const [audioEnabled, setAudioEnabled] = useState(true);
  // const [mediaStream, setMediaStream] = useState(null);
  // const [connection, setConnection] = useState(null);
  // const [cameraDevices, setCameraDevices] = useState([]);
  // const [selectedDeviceId, setSelectedDeviceId] = useState("");
  // //const [localStream, setLocalStream] = useState(null);
  // const [callStream, setcalllStream] = useState(null);

  // const deviceIdRef = useRef(null);

  const DefaultLocation = { lat: -0.5012984084076219, lng: -76.97750904233827 };

  const [currentFacingMode, setCurrentFacingMode] = useState("user");

  const [statusmessage, setStatusmessage] = useState(
    "Presiona el botón para iniciar la inspección virtual"
  );

  const [location, setLocation] = useState(DefaultLocation);
  const [searchlocation, setSearchLocation] = useState(false);

  const navigate = useNavigate();

  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState();

  const [modalContent, setmodalContent] = useState();

  const videoRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      currentLocation();
    }, 2000);

    var loadCall = false;
    console.log(evento);
    getEventByUrlApi(evento, "Cliente").then((response) => {
      setEvent(response.event);
      setTokendaily(response.token);
    });
  }, [evento]);

  function currentLocation() {
    setSearchLocation(true);
    var options = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(success, error, options);
  }

  function sendClientLocation(targetSessionId, requestId) {
    if (!callFrame.current) return;
    if (!navigator.geolocation) {
      callFrame.current.sendAppMessage(
        {
          type: "client-location",
          requestId,
          payload: { error: "Geolocalización no soportada" },
        },
        targetSessionId || "*"
      );
      return;
    }

    var options = {
      enableHighAccuracy: true,
      timeout: 8000,
      maximumAge: 0,
    };

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        var crd = pos.coords;
        callFrame.current.sendAppMessage(
          {
            type: "client-location",
            requestId,
            payload: {
              lat: crd.latitude,
              lon: crd.longitude,
              accuracy: crd.accuracy,
              timestamp: pos.timestamp,
            },
          },
          targetSessionId || "*"
        );

        UpdateLocationEventApi(
          { lat: crd.latitude, lon: crd.longitude },
          evento
        ).then((response) => {
          console.log(response);
        });
      },
      (err) => {
        callFrame.current.sendAppMessage(
          {
            type: "client-location",
            requestId,
            payload: { error: err.message, code: err.code },
          },
          targetSessionId || "*"
        );
      },
      options
    );
  }

  function success(pos) {
    var crd = pos.coords;

    setLocation({
      lat: crd.latitude,
      lng: crd.longitude,
    });

    UpdateLocationEventApi(
      { lat: crd.latitude, lon: crd.longitude },
      evento
    ).then((response) => {
      //setEvent(response.event);
      console.log(response);
    });

    setSearchLocation(false);
  }

  function error(err) {
    setSearchLocation(false);
    navigator.permissions
      .query({ name: "geolocation" })
      .then(function (result) {
        if (result.state === "granted") {
          console.log(result.state);
          //If granted then you can directly call your function here
        } else if (result.state === "prompt") {
          console.log(result.state);
        } else if (result.state === "denied") {
          console.log("location access denied by user");
          //If denied then you have to show instructions to enable location
        }
        result.onchange = function () {
          console.log(result.state);
        };
      });
    notification["error"]({
      message: `No se puede obtener la ubicación (Error: ${err.message})`,
    });
  }

  // useEffect(() => {
  //   var loadCall = false;
  //   if (selectedDeviceId && peerSave) {
  //     var getUserMedia =
  //       navigator.getUserMedia ||
  //       navigator.webkitGetUserMedia ||
  //       navigator.mozGetUserMedia;

  //     getUserMedia(
  //       { video: { deviceId: selectedDeviceId }, audio: true },
  //       (mediaStream) => {
  //         currentUserVideoRef.current.srcObject = mediaStream;
  //         currentUserVideoRef.current.play();

  //         setMediaStream(mediaStream);

  //         call.answer(mediaStream);
  //         call.on("stream", function (remoteStream) {
  //           if (!loadCall) {
  //             console.log("call stream " + loadCall);
  //             remoteVideoRef.current.srcObject = remoteStream;
  //             remoteVideoRef.current.play();
  //             loadCall = true;
  //           }

  //           setIsInCall(true);

  //           const recorder = new MediaRecorder(remoteStream);
  //           setMediaRecorder(recorder);

  //           recorder.ondataavailable = (event) => {
  //             if (event.data.size > 0) {
  //               setRecordedChunks((prevChunks) => [...prevChunks, event.data]);
  //             }
  //           };
  //         });
  //         call.on("close", function () {
  //           console.log("call close");
  //           loadCall = false;
  //           //loadCall = false;
  //           openNotificationWithIcon("error", "La inspección ha finalizado!");
  //           setAudioEnabled(true);
  //           setVideoEnabled(true);
  //           navigate(`/conferencia/finalizado/${evento}`);
  //           //navigate(0);
  //         });
  //       }
  //     );
  //   }
  // }, [selectedDeviceId, peerSave]);

  const openNotificationWithIcon = (type, text) => {
    notification[type]({
      message: "Notificación SafeRisk",
      description: text,
      placement: "bottomRight",
    });
  };

  const callInspector = async () => {
    setCalling(true);
    const iniciarSesion = async () => {
      try {
        // 🔥 DESTRUYE si ya existe una instancia previa
        if (callFrame.current) {
          try {
            callFrame.current.destroy();
          } catch (e) {
            console.warn("Error destruyendo instancia previa:", e);
          }
        }

        callFrame.current = DailyIframe.createFrame({
          iframeStyle: {
            position: "absolute",
            width: "100%",
            height: "100%",
            border: "0",
            borderRadius: "10px",
            top: "0",
            left: "0",
          },
          lang: "es",
          showLeaveButton: false,
          showFullscreenButton: false,
          showLocalVideo: true,
          showParticipantsBar: false,
          //showRemoteVideo: false,
          showUserNameChangeUI: false,
          activeSpeakerMode: false,
          //enablePrejoinUi: false,
          // enableChat: false,
          //enableScreenSharing: false,
          // enableRecording: false,
          // enableLocalAudio: true,
          // showDeviceSettings: true,
          //showLeaveButton: true,
          //showFullscreenButton: true,
          //showLocalVideo: true,
          //showParticipantsBar: true,
          //showUserNameChangeUI: true,
          //showRemoteVideo: true,
          //showDeviceSettings: true,
          //showLeaveButton: true,
        });

        setIsInCall(true);

        console.log("URL de la sala:", event.roomurl);
        console.log("Token de la sala:", tokendaily);

        callFrame.current.join({
          url: event.roomurl,
          token: tokendaily,
          startVideoOff: false,
          startAudioOff: false,
        });

        // // Bloquear recepción de video/audio de otros
        // callFrame.current.setSubscribeToTracksAutomatically(false);
        // callFrame.current.updateReceiveSettings({
        //   "*": { video: false },
        // });

        //Mostrar solo su propio video
        const localSessionId =
          callFrame.current.participants()?.local?.session_id;
        if (localSessionId) {
          callFrame.current.setUserData({
            layout: {
              kind: "single-participant",
              session_id: localSessionId,
            },
          });
        }

        const contenedor = document.getElementById("video-container");
        if (contenedor) contenedor.innerHTML = ""; // limpia ifr
        contenedor.appendChild(callFrame.current.iframe());
      } catch (err) {
        console.error("Error al conectar a la sala:", err);
        alert("Hubo un problema al conectarse. Intenta nuevamente.");
      }
    };

    if (callFrame.current) {
      await callFrame.current.destroy();
    }

    callFrame.current = DailyIframe.createCallObject({
      customLayout: true,
    });

    const joinCall = async () => {
      setStatusmessage("Solicitando permisos...");

      // 1. Obtener permisos explícitos antes de unirse
      let localStream;
      try {
        localStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });
      } catch (err) {
        alert("Se necesitan permisos de cámara y micrófono para continuar.");
        return;
      }

      setStatusmessage("Conectando al servicio...");

      // 1. Obtener stream local primero
      // const localStream = await navigator.mediaDevices
      //   .getUserMedia({
      //     video: true,
      //     audio: true,
      //   })
      //   .catch((err) => {
      //     throw new Error("Se necesitan permisos de cámara/micrófono");
      //   });

      await callFrame.current.join({
        url: event.roomurl,
        token: tokendaily,
      });

      //callFrame.current.setLocalVideo(false);
      // Configurar para mostrar solo la cámara local
      await callFrame.current.setLocalVideo(true); // Asegurar que la cámara local esté activa
      await callFrame.current.setLocalAudio(true); // Opcional: mantener audio activo

      // 4. Mostrar self-view al cliente
      // videoRef.current.srcObject = localStream;
      // videoRef.current
      //   .play()
      //   .catch((e) => console.warn("Auto-play prevenido:", e));

      // 5. Configurar recepción de medios (opcional)
      // callFrame.current.updateReceiveSettings({
      //   video: false, // El cliente no necesita ver al inspector
      //   audio: true, // Pero sí escucharlo
      // });

      setStatusmessage("Esperando al inspector...");
      setIsInCall(true);

      //Mostrar solo el stream local en el videoRef
      const localParticipant = callFrame.current.participants().local;
      console.log("Local participant:", localParticipant);

      if (localParticipant?.tracks?.video?.track) {
        videoRef.current.srcObject = new MediaStream([
          localParticipant.tracks.video.track,
        ]);
        videoRef.current.play();
      }

      // 6. Manejar eventos de conexión
      callFrame.current.on("participant-updated", (ev) => {
        if (!ev.participant.local) {
          console.log("Inspector conectado");
          // Aquí puedes agregar lógica adicional
          const participant = ev.participant;
          console.log("Participant updated:", participant);
          if (!participant.local && participant.tracks.audio.track) {
            const audioTrack = participant.tracks.audio.track;
            const remoteAudio = new Audio();
            remoteAudio.srcObject = new MediaStream([audioTrack]);
            remoteAudio
              .play()
              .catch((e) =>
                console.warn("No se pudo reproducir el audio remoto:", e)
              );
          }
        }
      });

      callFrame.current.on("app-message", async (event) => {
        const { data } = event;
        console.log("Mensaje recibido:", data);

        if (data?.type === "switch-client-camera") {
          const newFacingMode =
            currentFacingMode === "user" ? "environment" : "user";

          try {
            const stream = await navigator.mediaDevices.getUserMedia({
              video: { facingMode: newFacingMode },
              audio: true, // conserva audio
            });

            const videoTrack = stream.getVideoTracks()[0];

            await callFrame.current.setInputDevicesAsync({
              videoDeviceId: videoTrack.getSettings().deviceId,
            });

            // Actualizar vista local
            videoRef.current.srcObject = new MediaStream([videoTrack]);
            await videoRef.current.play();

            setCurrentFacingMode(newFacingMode); // Actualiza estado
          } catch (err) {
            console.error("Error al cambiar de cámara:", err);
          }
        } else if (data?.type === "toggle-client-audio") {
          const shouldEnableAudio = data.payload;
          callFrame.current.setLocalAudio(shouldEnableAudio);
        } else if (data?.type === "toggle-video") {
          const localVideo =
            callFrame.current.participants().local.tracks.video;
          console.log("Local video tracks:", localVideo);

          const isOn = localVideo?.state === "playable";
          console.log("Estado del video local:", isOn);

          callFrame.current.setLocalVideo(!isOn);

          if (!isOn) {
            // Mostrar video local
            const localParticipant = callFrame.current.participants().local;
            console.log("Local participant:", localParticipant);

            if (localParticipant?.tracks?.video?.track) {
              videoRef.current.srcObject = new MediaStream([
                localParticipant.tracks.video.track,
              ]);
              videoRef.current.play();
            } else {
              try {
                const stream = await navigator.mediaDevices.getUserMedia({
                  video: true,
                });

                const videoTrack = stream.getVideoTracks()[0];

                await callFrame.current.setInputDevicesAsync({
                  videoDeviceId: videoTrack.getSettings().deviceId,
                });

                // Si quieres mostrarlo en el video local:
                videoRef.current.srcObject = new MediaStream([videoTrack]);
                videoRef.current.play();

                // Finalmente, pedirle a Daily que encienda el video
                await callFrame.current.setLocalVideo(true);
              } catch (err) {
                console.error("Error al reactivar la cámara:", err);
              }
            }
          } else {
            videoRef.current.srcObject = null;
          }
        } else if (data?.type === "call-ended") {
          //alert(data.message); // o mostrar una notificación más elegante
          openNotificationWithIcon("info", data.message);
          callFrame.current.leave();
          callFrame.current.destroy();
          callFrame.current = null; // Limpieza explícita
          setIsInCall(false);
          // Puedes redirigir al usuario, mostrar un mensaje, etc.
          navigate(`/conferencia/finalizado/${evento}`);
        } else if (data?.type === "request-location") {
          sendClientLocation(event.from, data.requestId);
        }
      });

      // Opcional: Deshabilitar completamente la recepción de video remoto
      // callFrame.current.on("participant-updated", (ev) => {
      //   const participant = ev.participant;
      //   if (!participant.local) {
      //     // Ignorar completamente los streams remotos
      //     // O podrías detener explícitamente los tracks remotos:
      //     if (participant.tracks.video.track) {
      //       participant.tracks.video.track.stop();
      //     }
      //   }
      // });

      setIsInCall(true);
    };

    joinCall();

    //iniciarSesion();

    return () => {
      if (callFrame.current) {
        callFrame.current.leave();
        callFrame.current.destroy();
      }
    };
  };

  return (
    <Layout className="eventos">
      <Header className="eventos__header">
        <Row gutter={24}>
          <Col xs={6} sm={6} md={4} lg={4} xl={4}>
            <img alt="conecta2" src={Logo} style={{ width: "170px" }}></img>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Card
              size="small"
              title="Correo"
              headStyle={{ backgroundColor: "#175e92", color: "white" }}
              bodyStyle={{ fontWeight: "Bold", fontSize: "16px" }}
            >
              {event
                ? event.mail
                : "No existe la conferencia, por favor comunicarse con el agente"}
            </Card>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Card
              size="small"
              title="Teléfono móvil"
              headStyle={{ backgroundColor: "#175e92", color: "white" }}
              bodyStyle={{ fontWeight: "Bold", fontSize: "16px" }}
            >
              {event ? event.mobil : ""}
            </Card>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <Card
              size="small"
              title="Código de la conferencia"
              headStyle={{ backgroundColor: "#175e92", color: "white" }}
              bodyStyle={{ fontWeight: "Bold", fontSize: "16px" }}
            >
              {event ? event.code : ""}
            </Card>
          </Col>
        </Row>
        <br />
        {!isInCall && (
          <Row gutter={24}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ textAlign: "center" }}
            >
              {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
              <Button
                style={{ width: "200px", height: "200px" }}
                shape="circle"
                icon={<VideoCameraOutlined style={{ fontSize: "60px" }} />}
                size="large"
                onClick={() => callInspector()}
                loading={calling}
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              style={{ textAlign: "center" }}
            >
              {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
              <h2>{statusmessage}</h2>
            </Col>
          </Row>
        )}
        <Row gutter={24}>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}></Col>

          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            {/* <button onClick={() => call(remotePeerIdValue)}>Call</button> */}
            <div
              className={
                isInCall
                  ? "video-container-conference bakcground-video-image-conference"
                  : "video-container-conference"
              }
            >
              {/* <video
              ref={remoteVideoRef}
              className="background-video-conference"
            /> */}
              {/* <div id="video-container" className="background-video"></div> */}

              <video
                ref={videoRef}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "contain" /* Muestra todo el video sin recortar */,
                }}
                autoPlay
                //muted
                playsInline
              />

              {isInCall && <div className="control-buttons"></div>}
            </div>
          </Col>
        </Row>

        <div className="App">
          <ModalUser
            title={modalTitle}
            isVisibleModal={isVisibleModal}
            setIsVisibleModal={setIsVisibleModal}
            width={800}
          >
            {modalContent}
          </ModalUser>
        </div>
      </Content>
    </Layout>
  );
}
